import { GuestReservationHistoryItem, ReservationStatus } from '../types'

const UpcomingStatuses = [
  ReservationStatus.Pending,
  ReservationStatus.Confirmed,
  ReservationStatus.PendingReview,
  ReservationStatus.Inquiry,
  ReservationStatus.WaitingForTime,
]

/**
 * Whether a booking is still ahead: an open status and not yet over. Reads
 * the clock, so call it when the list is fetched, not during render.
 */
export default function isUpcomingReservation(
  reservation: Pick<
    GuestReservationHistoryItem,
    'businessDate' | 'startsAt' | 'endsAt' | 'status'
  >,
  now = Date.now(),
): boolean {
  const end =
    reservation.endsAt ??
    reservation.startsAt ??
    `${reservation.businessDate}T23:59:59Z`

  return (
    UpcomingStatuses.includes(reservation.status) &&
    new Date(end).getTime() >= now
  )
}
